<div class="control-container">
  <automata-automation-replacement-chips
    label="AUTOMATIONS.EDITOR.TASKS.ASSIGN_OWNER_CONTACT.OWNER"
    [formControl]="formControl"
    [dataService]="userSelectorService"
    [isRequired]="true"
    [multiple]="false"
    [supportedDataTypes]="supportedDataTypes"
    (finishedInitialLoading)="finishedLoadingSelector()"
    [extraData]="true"
  ></automata-automation-replacement-chips>
</div>
